<script type="text/javascript">
  export default {};
</script>

<template>
  <div class="market-detail-page-loader">
    <div class="market-detail-page-loader__content">
      <div class="market-detail-page-loader__text-1"></div>
      <div class="market-detail-page-loader__text-2"></div>
      <div class="market-detail-page-loader__text-3"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .market-detail-page-loader {
    @import '~styles/settings';

    display: flex;
    align-items: center;
    background: white;

    &--padding {
      padding: 12px 20px;
    }

    &__content {
      width: 100%;
    }

    &__text-1 {
      margin: 10px 0;

      @include text-line(50%, 30px);
    }

    &__text-2 {
      margin: 20px 0;

      @include text-line(70%, 40px);
    }
    &__text-3 {
      margin: 20px 0;

      @include text-line(100%, 380px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/MarketDetailPageLoader.vue